import { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";

import { Container, Grid, Switch, FormControlLabel } from "@material-ui/core";
import { EditOutlined, Add } from "@material-ui/icons";
import RedBall from "../../../assets/imgs/bolinha-vermelha.png";
import GreenBall from "../../../assets/imgs/bolinha-verde.png";

import SpeedDialErp from "../../../components/speeddial/SpeedDialErp";
import Loading from "../../../components/basics/Loading";
import TextField from "../../../components/basics/TextFieldErp";
import Btn from "../../../components/buttons/Btn";
import BigDataTable from "../../../components/tables/BigDataTable";

import HeaderModule from "../../../components/header/HeaderModule";
import { Margin } from "../../../theme/styles/Utils";
import {
  DespesasReembolsaveisContext,
  DespesasReembolsaveisContextProvider,
} from "./contexts/DespesasReembolsaveisContext";
import { BallContainer } from "../../prouser/transportadoras/styles/Transportadora";
import { QueryParamsContext } from "../../../context/QueryParamsContext";
import { TableContent } from "./styles/DespesasReembolsaveis";
import { GlobalVariables } from "../../../GlobalVariables";

const View = () => {
  const { queryParams } = useContext(QueryParamsContext);

  const { loading, dataTableReload } = useContext(DespesasReembolsaveisContext);

  const { push } = useHistory();

  const [textFilter, setTextFilter] = useState("");
  const [showOnlyActives, setShowOnlyActives] = useState(true);

  const [urlObjects] = useState({
    empresa_id: queryParams.empresa_id,
  });

  const [queryWhere, setQueryWhere] = useState({
    ativo: 1,
    descricao: ``,
  });

  useEffect(() => {
    if (
      Boolean(queryWhere.ativo) !== showOnlyActives ||
      queryWhere.descricao !== textFilter
    ) {
      setQueryWhere({
        ativo: showOnlyActives ? 1 : 0,
        descricao: encodeURIComponent(`${textFilter}`),
      });
    }
  }, [textFilter, showOnlyActives, queryWhere.ativo, queryWhere.descricao]);

  const columns = [
    {
      disabled: true,
      id: "acoes",
      label: "Ações",
      align: "center",
      style: { maxWidth: 5 },
      format: (item) => (
        <SpeedDialErp
          actions={[
            {
              icon: <EditOutlined />,
              name: "Editar",
              action: () => push("cadastro", { id: item.id }),
            },
          ]}
        />
      ),
    },
    {
      id: "id",
      label: "ID",
    },
    {
      id: "descricao",
      label: "Descrição",
      style: { minWidth: 500 },
    },
    {
      id: "servico",
      label: "Serviço",
      format: (item) =>
        item?.contratoservico?.descricao
          ? `${item.servico} - ${item.contratoservico.descricao}`
          : item.servico,
    },
    {
      id: "ativo",
      label: "Ativo",
      align: "center",
      format: (value) =>
        value.ativo === 1 ? (
          <BallContainer>
            <img src={GreenBall} alt="ativo" />
          </BallContainer>
        ) : (
          <BallContainer>
            <img src={RedBall} alt="inativo" />
          </BallContainer>
        ),
    },
  ];

  return (
    <>
      <Loading open={loading} />
      <HeaderModule
        title="CADASTRO DE DESPESAS REEMBOLSÁVEIS"
        videoId={GlobalVariables.screenVideosIds.cadastroDespesasReembolsaveis}
      />
      <Margin top={80} />
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid
            item
            container
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <Grid item xs={6} sm={6} md={6}>
              <TextField
                value={textFilter}
                setValue={setTextFilter}
                label="Busque por Descrição"
                variant="filled"
              />
            </Grid>

            <Grid item xs={6} sm={6} md={3} lg={3}>
              <FormControlLabel
                control={
                  <Switch
                    checked={showOnlyActives}
                    onChange={() => setShowOnlyActives((current) => !current)}
                    color="primary"
                  />
                }
                label="Ativos"
                labelPlacement="end"
              />
            </Grid>

            <Grid item flex={1}>
              <Btn
                label="Novo"
                startIcon={<Add />}
                onClick={() => push("cadastro")}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TableContent>
              <BigDataTable
                tableTitle=""
                route="faturamento/despesas-reembolsaveis/v1/empresa"
                columns={columns}
                where={queryWhere}
                urlObjects={urlObjects}
                reload={dataTableReload}
              />
            </TableContent>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

const DespesasReembolsaveisListagem = () => (
  <DespesasReembolsaveisContextProvider>
    <View />
  </DespesasReembolsaveisContextProvider>
);

export default DespesasReembolsaveisListagem;
